module.exports = __webpack_public_path__ + "static/img/column_recommendation1_1.6eab65ca.png";